export default __webpack_public_path__ + "static/media/L4.25a59dfc.png";